import { menuFr as libMenuFr } from '@rfc/rfc-components-library/locales'

export const menuFr = {
    ...libMenuFr,
    customers: 'Clients',
    orders: 'Commandes',
    templates: "Gabarits d'impression",
    products: 'Produits',
    productionLines: 'Lignes de production',
    adminOrders: 'Commandes',
    adminTemplates: "Gabarits d'impression",
    adminCustomers: 'Clients',
    adminProducts: 'Produits',
    adminProductionLines: 'Lignes de production'
}
